import { Table } from 'ui/table';
import { AlignTypes, ColumnData } from 'ui/tableHeader';
import { useWebPushMetadataContext } from '../context';
import { useCreateIntegrationTableRow } from '../utils';
import {
  RowCell,
  SectionHeader,
  StyledTableHeader,
  StyledTableRows,
  TableContainer,
} from './styles';

const createColumn = (displayName: string, rowName: string): ColumnData & { RowCell: any } => ({
  name: displayName,
  value: rowName,
  align: 'flex-start',
  sortable: false,
  RowCell: ({ row }: any) => <RowCell data-test={`row-cell-${rowName}`}>{row[rowName]}</RowCell>,
});

export const WebPushIntegrationTable = () => {
  const { isLegacyIntegration } = useWebPushMetadataContext();

  const columns = [
    createColumn('Type', 'type'),
    ...(isLegacyIntegration ? [createColumn('Server key', 'serverKey')] : []),
    { ...createColumn('', 'actions'), align: 'flex-end' as AlignTypes },
  ];

  const row = useCreateIntegrationTableRow();

  return (
    <TableContainer data-test="web-push-integration-table">
      <SectionHeader>Integrations</SectionHeader>
      <Table>
        <StyledTableHeader columns={columns} />
        <StyledTableRows columns={columns} rows={[row]} />
      </Table>
    </TableContainer>
  );
};
